import { Container } from '@mui/material';

import { Page } from '../../../../components';
import { EventMap } from '../../../../components/event-map';

export function EventListScreen () {
    return (
        <Page title="POM - System Monitoring">
            <Container maxWidth={false}>
                <EventMap />
            </Container>
        </Page>
    )
}